import { WebAuthnError } from "@simplewebauthn/browser";

import {
  WEBAUTHN_ERROR_ALREADY_REGISTERED,
  WEBAUTHN_ERROR_MESSAGES,
  WEBAUTHN_ERROR_NO_CREDENTIAL_OR_CANCELLED,
  WEBAUTHN_ERROR_UNKNOWN,
  WEBAUTHN_ERROR_UNSUPPORTED,
} from "constants/webauthn";

const NO_CREDENTIAL_OR_CANCELLED_ERROR_CODES = [
  "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
  "ERROR_CEREMONY_ABORTED",
  "ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE",
];

const UNSUPPORTED_ERROR_CODES = [
  "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
  "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
  "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
];

const ALREADY_REGISTERED_ERROR_CODES = [
  "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
];

export function humanizeWebAuthnError(error: unknown): string {
  if (!(error instanceof WebAuthnError)) {
    return WEBAUTHN_ERROR_MESSAGES[WEBAUTHN_ERROR_UNKNOWN];
  }

  if (ALREADY_REGISTERED_ERROR_CODES.includes(error.code)) {
    return WEBAUTHN_ERROR_MESSAGES[WEBAUTHN_ERROR_ALREADY_REGISTERED];
  }

  if (NO_CREDENTIAL_OR_CANCELLED_ERROR_CODES.includes(error.code)) {
    return WEBAUTHN_ERROR_MESSAGES[WEBAUTHN_ERROR_NO_CREDENTIAL_OR_CANCELLED];
  }

  if (UNSUPPORTED_ERROR_CODES.includes(error.code)) {
    return WEBAUTHN_ERROR_MESSAGES[WEBAUTHN_ERROR_UNSUPPORTED];
  }

  return WEBAUTHN_ERROR_MESSAGES[WEBAUTHN_ERROR_UNKNOWN];
}
